/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import ServiceApi from "../../../../services/ServiceApi";

export default function Mainjobtype() {
  const [statusbtn, setstatusbtn] = useState(0);
  return (
    <>
      <div style={{ textAlign: "center" }} className="mt-5 mb-5">
        <button
          className={
            statusbtn === 1 ? "btndisabled ml-3 p-1" : "btnImport ml-3 p-1"
          }
        >
          <img
            style={{
              float: "left",
              marginTop: "3px",
              marginLeft: "10px",
            }}
            src={
              statusbtn === 1
                ? ServiceApi.absoluteUrl("/img/Manul.svg")
                : ServiceApi.absoluteUrl("/img/Manuldis.svg")
            }
          />{" "}
          <span style={{ marginLeft: "-20px", fontSize: "18px" }}>Manual</span>
          <img
            style={{ float: "right", marginTop: "-10px" }}
            src={
              statusbtn === 1
                ? ServiceApi.absoluteUrl("/icon/btncircledis.svg")
                : ServiceApi.absoluteUrl("/icon/btncircle.svg")
            }
          />
        </button>
      </div>
    </>
  );
}
